<template>
  <div class="container-fluid py-4 configuration-page">

    <!-- ================= HEADER ================= -->
    <div class="header-boutique d-flex justify-content-between align-items-center mb-4 flex-wrap">

      <div class="d-flex align-items-center gap-3">

        <div class="icon-box">
          <i class="bi bi-shop"></i>
        </div>

        <div>
          <h2 class="fw-bold mb-0">
            Création Configuration Boutique
          </h2>

          <p class="mb-0 text-header">
            Paramètres généraux de la Boutique Baraka
          </p>
        </div>

      </div>

      <div class="breadcrumb-boutique mt-3 mt-md-0">
        <span>Paramètres</span>
        <i class="bi bi-chevron-right"></i>
        <span>Configuration</span>
        <i class="bi bi-chevron-right"></i>
        <strong>Création</strong>
      </div>

    </div>

    <!-- ================= CARD ================= -->
    <div class="card-boutique">

      <!-- SECTION TITLE -->
      <div class="section-title mb-4">
        <i class="bi bi-gear"></i>
        <span>Informations de la boutique</span>
      </div>

      <!-- FORM -->
      <div class="row g-4">

        <!-- NOM -->
        <div class="col-12 col-md-6">

          <label class="form-label label-boutique">
            Nom de la boutique
          </label>

          <input
            type="text"
            v-model="form.nomClinique"
            class="form-control input-boutique"
            :class="{ 'is-invalid': errors.nomClinique }"
            placeholder="Ex : Boutique Baraka"
          />

          <div class="invalid-feedback">
            {{ errors.nomClinique }}
          </div>

        </div>

        <!-- VILLE -->
        <div class="col-12 col-md-6">

          <label class="form-label label-boutique">
            Ville
          </label>

          <input
            type="text"
            v-model="form.villeClinique"
            class="form-control input-boutique"
            :class="{ 'is-invalid': errors.villeClinique }"
            placeholder="Ex : Bamako"
          />

          <div class="invalid-feedback">
            {{ errors.villeClinique }}
          </div>

        </div>

        <!-- TELEPHONE -->
        <div class="col-12 col-md-6">

          <label class="form-label label-boutique">
            Téléphone
          </label>

          <input
            type="text"
            v-model="form.telephone"
            class="form-control input-boutique"
            :class="{ 'is-invalid': errors.telephone }"
            placeholder="Ex : +223 70 00 00 00"
          />

          <div class="invalid-feedback">
            {{ errors.telephone }}
          </div>

        </div>

        <!-- ADRESSE -->
        <div class="col-12 col-md-6">

          <label class="form-label label-boutique">
            Adresse
          </label>

          <input
            type="text"
            v-model="form.adresse"
            class="form-control input-boutique"
            :class="{ 'is-invalid': errors.adresse }"
            placeholder="Ex : ACI 2000 Bamako"
          />

          <div class="invalid-feedback">
            {{ errors.adresse }}
          </div>

        </div>

        <!-- LOGO -->
        <div class="col-12 col-md-6">

          <label class="form-label label-boutique">
            Logo de la boutique
          </label>

          <input
            type="file"
            class="form-control input-boutique"
            @change="handleFileUpload"
            accept="image/*"
          />

        </div>

        <!-- DESCRIPTION -->
        <div class="col-12">

          <label class="form-label label-boutique">
            Description
          </label>

          <textarea
            v-model="form.description"
            class="form-control input-boutique"
            rows="5"
            placeholder="Description de la boutique..."
          ></textarea>

        </div>

      </div>

      <!-- ACTIONS -->
      <div class="actions-wrapper">

        <button class="btn btn-cancel" @click="cancel">
          <i class="bi bi-x-circle me-2"></i>
          Annuler
        </button>

        <button class="btn btn-save" @click="saveConfiguration">
          <i class="bi bi-check-circle me-2"></i>
          Enregistrer
        </button>

      </div>

    </div>

  </div>
</template>
<script>
import api from '@/api';

export default {
  name: 'CreateConfigurationBoutique',

  data() {
    return {
      logoFile: null,

      form: {
        nomClinique: '',
        villeClinique: '',
        adresse: '',
        telephone: '',
        description: '',
        logo: ''
      },

      errors: {}
    };
  },

  methods: {

    validateForm() {

      this.errors = {
        nomClinique: this.form.nomClinique
          ? ''
          : 'Le nom de la boutique est requis',

        villeClinique: this.form.villeClinique
          ? ''
          : 'La ville est requise',

        adresse: this.form.adresse
          ? ''
          : "L'adresse est requise",

        telephone: this.form.telephone
          ? ''
          : 'Le téléphone est requis'
      };

      return !Object.values(this.errors).some(e => e !== '');
    },

    async saveConfiguration() {

      if (!this.validateForm()) return;

      try {

        const formData = new FormData();

        // 👇 IMPORTANT : on garde tes variables backend actuelles
        formData.append('nom', this.form.nomClinique);
        formData.append('ville', this.form.villeClinique);
        formData.append('adresse', this.form.adresse);
        formData.append('telephone', this.form.telephone);
        formData.append('description', this.form.description);

        if (this.logoFile) {
          formData.append('logoFile', this.logoFile);
        }

        await api.createItem('configurations', formData, true);

        alert('Configuration Boutique Baraka enregistrée avec succès !');

        this.$router.push({
          name: 'item_config'
        });

      } catch (error) {
        console.error(error);
        alert("Erreur lors de l'enregistrement");
      }
    },

    cancel() {
      this.$router.push({
        name: 'item_config'
      });
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) this.logoFile = file;
    }

  }
};
</script>
<style scoped>

/* PAGE */
.configuration-page {
  background: #f5f7fb;
  min-height: 100vh;
}

/* HEADER */
.header-boutique {
  background: linear-gradient(135deg, #064e3b, #10b981);
  padding: 20px;
  border-radius: 18px;
  color: white;
  box-shadow: 0 10px 25px rgba(0,0,0,0.08);
}

/* ICON */
.icon-box {
  width: 60px;
  height: 60px;
  border-radius: 16px;

  background: rgba(255,255,255,0.1);

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 26px;
}

/* TEXT HEADER */
.text-header {
  color: rgba(255,255,255,0.75);
  font-size: 14px;
}

/* BREADCRUMB */
.breadcrumb-boutique {
  display: flex;
  align-items: center;
  gap: 10px;

  background: rgba(255,255,255,0.1);
  padding: 10px 15px;
  border-radius: 12px;

  font-size: 14px;
}

/* CARD */
.card-boutique {
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 5px 25px rgba(0,0,0,0.05);
}

/* TITLE */
.section-title {
  display: flex;
  align-items: center;
  gap: 12px;

  font-size: 18px;
  font-weight: 700;
  color: #064e3b;
}

.section-title i {
  width: 45px;
  height: 45px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: linear-gradient(135deg, #064e3b, #10b981);
  color: white;
}

/* LABEL */
.label-boutique {
  font-weight: 600;
  color: #334155;
  margin-bottom: 8px;
}

/* INPUT */
.input-boutique {
  border-radius: 12px;
  border: 1px solid #dbe3ee;
  padding: 12px 15px;
}

.input-boutique:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 0.2rem rgba(16,185,129,0.15);
}

/* ACTIONS */
.actions-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 35px;
  flex-wrap: wrap;
}

/* BUTTONS */
.btn-save {
  background: linear-gradient(135deg,#064e3b,#10b981);
  border: none;
  color: white;
  padding: 12px 22px;
  border-radius: 12px;
  font-weight: 600;
}

.btn-cancel {
  background: #ef4444;
  border: none;
  color: white;
  padding: 12px 22px;
  border-radius: 12px;
  font-weight: 600;
}

/* MOBILE */
@media (max-width: 768px) {

  .card-boutique {
    padding: 20px;
  }

  .actions-wrapper {
    flex-direction: column;
  }

  .btn-save,
  .btn-cancel {
    width: 100%;
  }

  .breadcrumb-boutique {
    width: 100%;
    overflow-x: auto;
  }

}

</style>